// extracted by mini-css-extract-plugin
export default {"modal":"modal__k0qvf","title":"title__iNGYq","campaignInstruction":"campaignInstruction__oP2+g","instruction":"instruction__u0FX-"};